import script from "./Payroll-Configuration-Questionnaire-Step1.vue?vue&type=script&setup=true&lang=js"
export * from "./Payroll-Configuration-Questionnaire-Step1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__